import { NAMESPACE as APP_NAMESPACE } from '../../app';

let service;

export default {
    async fetchSavedSettings({ commit, dispatch }) {
        try {
            commit('showLoader', true);

            const data = await service.getSavedSettings();
            commit('parseStoredDataResponse', data);

            commit('showLoader', false);
        } catch (err) {
            dispatch('handleError', err);
        }
    },
    async saveSettings({ commit, dispatch }, settings) {
        try {
            commit('showLoader', true);

            commit('setJqlTestResult', undefined);
            commit('setWiqlTestResult', undefined);
            await service.saveSettings(settings);
            dispatch('showPopup', {
                type: 'success',
                title: 'Success',
                message: 'Successfully saved filter settings.',
            });

            commit('showLoader', false);
            return true;
        } catch (err) {
            dispatch('handleError', err);
            return false;
        }
    },
    async testJqlQuery({ commit, dispatch }, query) {
        try {
            commit('showLoader', true);
            const testResult = await service.testQuery({ type: "jql", query });
            commit('setJqlTestResult', testResult);
            commit('showLoader', false);
        } catch (err) {
            dispatch('handleError', err);
        }
    },
    async testWiqlQuery({ commit, dispatch }, query) {
        try {
            commit('showLoader', true);
            const testResult = await service.testQuery({ type: "wiql", query });
            commit('setWiqlTestResult', testResult);
            commit('showLoader', false);
        } catch (err) {
            dispatch('handleError', err);
        }
    },
    showPopup({ dispatch }, { title, type, message }) {
        dispatch(
            APP_NAMESPACE.actions.SEND_NOTIFICATION, {
                receiver: 'MessageBox',
                payload: { title, type, message },
            },
            { root: true },
        );
    },
    setService(_, payload) {
        service = payload.service;
    },
    handleError({ commit, dispatch }, error) {
        commit('showLoader', false);
        dispatch(APP_NAMESPACE.actions.HANDLE_ERROR, error, { root: true });
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/filters/actions.js